<template>
  <div>
    <!-- <img /> -->
    <Daikan />
    <Header />
    <div class="bottomFunction">
      <div class="flex" style="width: 20px"></div>
      <div
        :class="value == index ? 'active flex' : 'flex'"
        v-for="(item, index) in list"
        :key="index"
        @click="open(item, index)"
      >
        <div class="box">
          <img
            src="../assets/newImg/line.png"
            alt=""
            class="line"
            v-if="value == index"
          />
          <svg-icon
            :icon-class="item.icon"
            :style="
              value == index
                ? 'color: #fff;margin-right: 8px'
                : 'color: #536b8e;margin-right: 8px'
            "
          />
          {{ item.name }}
          <transition
            enter-active-class="animated fadeInUp"
            leave-active-class="animated fadeOutDown"
          >
            <div class="listBox" v-if="item.list && index == value">
              <div
                :class="value1 == index1 ? 'list listactive' : 'list'"
                v-for="(item1, index1) in item.list"
                :key="index1"
                :style="'transform:' + 'translateX(' + 19 * index1 + 'px)'"
                @click.stop="open1(item, index1)"
              >
                {{ item1 }}
              </div>
            </div>
          </transition>
        </div>
      </div>

      <transition
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutDown"
      >
        <div class="flex1" v-if="sitFlag == true">
          <div
            :class="value == index + num ? 'active flex' : 'flex'"
            v-for="(item, index) in sitList"
            :key="index"
            @click="open(item, index + num)"
          >
            <div class="box">
              <img
                src="../assets/newImg/line.png"
                alt=""
                class="line"
                v-if="value == index + num"
              />
              <svg-icon
                :icon-class="item.icon"
                :style="
                  value == index + num
                    ? 'color: #fff;margin-right: 8px'
                    : 'color: #536b8e;margin-right: 8px'
                "
              />
              {{ item.name }}

              <transition
                enter-active-class="animated fadeInUp"
                leave-active-class="animated fadeOutDown"
              >
                <div class="listBox" v-if="item.list && index + num == value">
                  <div
                    :class="value1 == index1 ? 'list listactive' : 'list'"
                    v-for="(item1, index1) in item.list"
                    :key="index1"
                    :style="'transform:' + 'translateX(' + 19 * index1 + 'px)'"
                    @click.stop="open1(item, index1)"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Daikan from "./daikan.vue";
import Header from "./header.vue";
export default {
  data() {
    return {
      value: 99,
      value1: 99,
      list: [],
      num: 0,
      topValue: 0,
      topList: [
        { name: "COMMEND", icon: "bmwicon_地图" },
        { name: "APPLAUSE", icon: "bmwicon_邀请1" },
        { name: "CHAT", icon: "bmwicon_拍照" },
        { name: "APPLAUSE", icon: "bmwicon_净化ui" },
        { name: "CHAT", icon: "bmwicon_退出" },
      ],
      userList: [
        { name: "COMMEND", icon: "bmwicon_点赞" },
        { name: "APPLAUSE", icon: "bmwicon-鼓掌" },
        {
          name: "CONVEY",
          icon: "bmwicon_传送",

          list: ["FIRST FLOOR", "SECOND FLOOR", "THIRD FLOOR"],
        },
        { name: "CALL", icon: "bmwicon-聊天" },
      ],

      vipList: [
        { name: "COMMEND", icon: "bmwicon_点赞" },
        { name: "APPLAUSE", icon: "bmwicon-鼓掌" },
        { name: "ACTION", icon: "bmwicon-动作", list: ["WAVE HAND", "APPLAUSE"] },
        {
          name: "CONVEY",
          icon: "bmwicon_传送",

          list: ["FIRST FLOOR", "SECOND FLOOR", "THIRD FLOOR"],
        },
        { name: "CALL", icon: "bmwicon-聊天" },
      ],

      zcrList: [
        {
          name: "SALES",
          icon: "bmwicon-回应",
        },
        { name: "COMMEND", icon: "bmwicon_点赞" },
        { name: "APPLAUSE", icon: "bmwicon-鼓掌" },

        {
          name: "ACTION",
          icon: "bmwicon-动作",
          list: ["WAVE HAND", "APPLAUSE"],
        },
        {
          name: "CONVEY",
          icon: "bmwicon_传送",

          list: ["FIRST FLOOR", "SECOND FLOOR", "THIRD FLOOR"],
        },
      ],

      sitFlag: false,
      sitList: [{ name: "STAND UP", icon: "bmwicon_起立" }],

      callFlag: false,

      daikanFlag: false,
    };
  },
  components: { Daikan, Header },
  methods: {
    zipai() {
      var date = new Date().getTime();
      // var name = `自拍${date}`;
      this.compress(document.o2.shot(), 1080, 1080).then((res) => {
        this.$notify({
          title: "成功",
          message: "自拍成功",
          type: "success",
        });
      });
    },

    dataURLToBlob(dataurl) {
      //ie 图片转格式
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    compress(base64String, w, quality) {
      let a = document.createElement("a");
      a.style.display = "none";
      var that = this;
      var getMimeType = function (urlData) {
        var arr = urlData.split(",");
        var mime = arr[0].match(/:(.*?);/)[1];
        // return mime.replace("image/", "");
        return mime;
      };
      var newImage = new Image();
      var imgWidth, imgHeight;

      var promise = new Promise((resolve) => (newImage.onload = resolve));
      newImage.src = base64String;

      return promise.then(() => {
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);

        let imgobj = new Image();
        imgobj.src = "";

        var base64 = canvas.toDataURL(getMimeType(base64String), quality);
        var blob = that.dataURLToBlob(base64);
        a.setAttribute("href", URL.createObjectURL(blob));
        a.setAttribute("download", "自拍.png");
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);

        // return base64;
      });
    },
    top(e) {
      if (e == 0) {
        console.log("地图");
      }

      if (e == 1) {
        console.log("邀请");
      }

      if (e == 2) {
        this.zipai();
      }

      if (e == 3) {
        this.allshow = !this.allshow;
      }

      if (e == 4) {
        this.loginOut();
      }
    },
    open(item, index) {
      console.log(index, this.num);
      this.value1 = 99;
      if (this.value == index) {
        this.value = 99;
      } else if (item.list) {
        this.value = index;
      }

      if (item.name == "COMMEND") {
        let str = "1056,gif,1";
        this.$chat.ws.send(str);
        this.value = 99;
      }

      if (item.name == "CALL") {
        let str = "1056,gif,2";
        this.$chat.ws.send(str);
      }
      if (item.name == "APPLAUSE") {
        let str = "1056,gif,0";
        this.$chat.ws.send(str);
        this.value = 99;
      }

      if (item.name == "CALL") {
        if (this.daikanFlag) {
          this.$message.error("您已进入带看模式");
          return;
        }
        this.callFlag = !this.callFlag;
        let info = { msg: "call", data: this.$chat.role.id, flag: this.callFlag };
        console.log(info);
        let str = 1056 + "," + JSON.stringify(info);
        this.$chat.ws.send(str);
      }

      if (item.name == "SALES") {
        this.Bus.$emit("sales", "");
      }

      if (item.name == "STAND UP") {
        this.Bus.$emit("stand", "");
        this.value = 99;
      }
    },

    open1(item, index) {
      this.value1 = index;
      console.log(item);

      var clipName = "";
      if (item.name == "VIEW") {
        document.o2.switch_view(index);
      }

      if (item.name == "ANIMATION") {
        document.o2.play_animation(index);
      }
      if (item.name == "CONVEY") {
        if (this.sitFlag) {
          this.$message.error("坐下无法传送");
          return;
        }
        if (index == 0) {
          document.o2.setRolePos(0, -1118, 13874, 0, -268, 17464);
          document.o2.do_port_ani(0, -1118, 13874);
        } else if (index == 1) {
          document.o2.setRolePos(-11932, 6378, -19106, -13742, 8531, -22087);
          document.o2.do_port_ani(-11932, 6378, -19106);
        } else if (index == 2) {
          document.o2.setRolePos(-14142, 13431, -10237, -16939, 15934, -10324);
          document.o2.do_port_ani(-14142, 13431, -10237);
        }
      }

      if (item.name == "ACTION") {
        if (index == 0) {
          clipName = "wave";
        }

        if (index == 1) {
          if (document.o2.role.state != "sit") {
            clipName = "standClap";
          } else {
            clipName = "clap";
          }
        }
      }

      if (clipName && clipName != "") {
        console.log(clipName);
        document.o2.role.playClip(clipName, false, false);
        let msg = 1056 + ",";
        let info = { msg: "playClip", data: clipName };
        msg += JSON.stringify(info);
        this.$chat.ws.send(msg);
      }
    },

    loginOut() {
      this.$confirm(this.$t("info.lang.logOutInfo"))
        .then((_) => {
          localStorage.removeItem("info");
          location.reload();
          done();
        })
        .catch((_) => {});
    },
  },

  mounted() {},
  created() {
    this.Bus.$on("onRoleLoaded", (role) => {
      role.onStateChg.push((state) => {
        if (state == "sit") {
          this.sitFlag = true;
        } else {
          this.sitFlag = false;
        }
      });
    });
    this.Bus.$on("daikanFlag", (e) => {
      this.daikanFlag = e;
    });

    this.Bus.$on("loginS", () => {
      this.auth = this.$chat.role.auth;

      if (this.auth > 2 && this.auth < 5) {
        this.list = this.vipList;
      } else if (this.auth == 5) {
        this.list = this.zcrList;
        console.log(this.$chat.role.id);
        setTimeout(() => {
          document.client.join(Number(this.$chat.role.id));
        }, 2000);
      } else {
        this.list = this.userList;
      }

      this.num = this.list.length + 1;
    });
  },
};
</script>

<style style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  height: 58px;
  transform: skew(-34deg);
  color: #536b8e;
}
.flex1 {
  display: flex;
}

.flex:after {
  content: "";
  position: absolute;
  left: auto;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  height: 50%;
  width: 2px;
  background-color: #000;
  opacity: 0.1;
}
.topFunction {
  width: 48.02px;
  height: 300px;
  background: url("../assets/newImg/topfunction.png");
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: 15px;
}
.bottomFunction {
  bottom: 0;
  left: 0;
  position: fixed;
  background: url("../assets/newImg/bottomfunction.png");
  background-size: 100% 100%;
  width: 1920px;
  height: 98px;
  display: flex;
  align-items: center;
  z-index: 1;
  .box {
    margin: 0 45px 0 40px;
    font-size: 13.34px;
    font-family: BMW Group, BMW Group-Bold;
    font-weight: bold;
    text-align: left;

    display: flex;
    align-items: center;
    cursor: pointer;
    transform: skew(34deg);
    width: 120px;
    position: relative;
    justify-content: center;
  }

  .active {
    background: #879cbb;
    transition: linear 0.5s;
    color: #fff !important;
  }

  img {
    width: 25px;
    margin-right: 6px;
  }
}
.line {
  width: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: -40px;
}

.listBox {
  position: absolute;
  bottom: 40px;
  left: -22px;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;

  .list {
    width: 225px;
    height: 30px;
    background: url("../assets/newImg/list.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
    color: #536b8e;
  }

  .listactive {
    background: url("../assets/newImg/list_active.png");
    background-size: 100% 100%;
    color: white;
  }
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  color: pointer;
}

@media screen and (max-width: 1400px) {
  .bottomFunction {
    .box {
      font-size: 12px;
      margin: 0 4px;
    }

    .list {
      width: 145px;
    }

    .listBox {
      left: 12px;
    }

    .line {
      display: none;
    }
  }
}
</style>
